import { option } from 'fp-ts';
import { useCallback } from 'react';
import { Drawer } from 'ui/drawer';
import { isDefined } from 'utils/tsHelpers';
import { ExpandModes, useExpansionContext } from 'utils/contexts/expansion';
import { useCatalogContext } from 'modules/catalog/catalogSelector';

import { Footer } from './Footer';
import { CatalogPreviewTable } from './CatalogPreviewTable';
import { QueryBuilder } from './QueryBuilder';
import { Title } from './Title';
import { Selector } from './Selector';
import { Divider } from './Divider';
import { useCatalogPreviewContext } from './contexts/CatalogPreviewContext';
import { useUpdateCatalogDrawer } from './hooks/useUpdateCatalogDrawer';
import { useResetCatalogDrawer } from './hooks/useResetCatalogDrawer';
import { useCatalogQueryContext } from 'modules/segmentation/contexts/catalogQuery';
import { useCatalogSelectionContext } from './contexts/CatalogSelectionContext';
import { useCatInSegQueryBuilderV2FeatureFlag } from './hooks/useCatInSegQueryBuilderV2FeatureFlag';

export const CatalogQueryDrawerContent = () => {
  const { closePreview } = useCatalogPreviewContext();
  const { setIsEnabled } = useCatalogSelectionContext();
  const isFeatureFlagged = useCatInSegQueryBuilderV2FeatureFlag();
  const { catalogQueryDetails } = useCatalogQueryContext();
  const { catalogFieldDetails, catalog } = useCatalogContext();
  const { collapse, mode } = useExpansionContext();
  useUpdateCatalogDrawer();
  useResetCatalogDrawer();

  const hasSearchQuery = isDefined(catalogQueryDetails?.catalogQuery?.searchQuery);
  const hasCatalogField = option.isSome(catalogFieldDetails);
  const hasNoCatalogQueryField = !isDefined(catalogQueryDetails?.catalogField);
  const hasCatalog = option.isSome(catalog);

  const closePreviewAndCollapseDrawer = useCallback(() => {
    closePreview();
    collapse();
    if (isFeatureFlagged && hasCatalog && hasCatalogField)
      setIsEnabled(hasNoCatalogQueryField || hasSearchQuery);
  }, [isFeatureFlagged, hasCatalog, hasCatalogField, hasNoCatalogQueryField, hasSearchQuery]);

  return (
    <Drawer
      title={<Title />}
      footer={<Footer />}
      onClose={closePreviewAndCollapseDrawer}
      isExpanded={mode === ExpandModes.expand}
    >
      <Selector />
      <Divider />
      <QueryBuilder />
      <CatalogPreviewTable />
    </Drawer>
  );
};
